import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { DropdownItemProps /* , Form, Input */ } from 'semantic-ui-react';
import { EventInstructorRole } from 'stores/events/events-store';
import TailwindSelect from 'widgets/editors/tailwind-select';

interface TailwindEventInstructorRoleEditorProps extends WithTranslation {
  value: EventInstructorRole;
  onChange?: (value: EventInstructorRole) => void;
  placeholder?: string;
  className?: string;
  readOnly?: boolean;
}

interface TailwindEventInstructorRoleEditorState {
  options: DropdownItemProps[];
}

class TailwindEventInstructorRoleEditor extends React.Component<
  TailwindEventInstructorRoleEditorProps,
  TailwindEventInstructorRoleEditorState
> {
  constructor(props: TailwindEventInstructorRoleEditorProps) {
    super(props);
    this.state = {
      options: this.getAllEventInstructorRoles()
    };
  }

  public render() {
    return (
      <TailwindSelect
        options={this.state.options.map(opt => ({
          id: opt.value?.toString(),
          text: opt.text?.toString()
        }))}
        value={EventInstructorRole[this.props.value]?.toString() || ''}
        onChange={value => this.handleOnSelection(value)}
        placeholder={this.props.placeholder || 'Select an option'}
        clearable
        searchable
        className={`${this.props.className} w-full`}
        disabled={this.props.readOnly}
      />
    );
  }

  private handleOnSelection(value) {
    let eventInstructorRoleStr: string = value;
    let eventInstructorRole: EventInstructorRole = EventInstructorRole[eventInstructorRoleStr];
    this.props.onChange(eventInstructorRole);
  }

  private getAllEventInstructorRoles() {
    let map: { text: string; value: string }[] = [];

    for (let n in EventInstructorRole) {
      if (typeof EventInstructorRole[n] === 'number') {
        map.push({ text: n, value: EventInstructorRole[n] });
      }
    }

    return map;
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(TailwindEventInstructorRoleEditor);
